import template from './inArrears.html';
import controller from './inArrearsCtrl.js';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    tab: '<',
    filterData: '<',
    dateSentFeature: '<',
    filterUpdateCount: '<',
    refreshCount: '<',
    onTableDataLoaded: '&',
    onSendModal: '&',
    viewContact: '&',
  },
};
